import { ChangeEvent, InputHTMLAttributes } from "react";
import { FieldError } from "react-hook-form";
import { input, InputVariantProps } from "./input.variants";
import { Mask, masks } from "@/utils";

export type UseInputProps = InputVariantProps &
  InputHTMLAttributes<HTMLInputElement> & {
    className?: string;
    ref?: React.Ref<HTMLInputElement>;
    label?: string;
    mask?: Mask;
    error?: FieldError;
    hideLabel?: boolean;
  };

export const useInput = (props: UseInputProps) => {
  const {
    ref,
    className = "",
    id,
    name,
    label,
    hideLabel = false,
    color = "light",
    type = "text",
    mask,
    onChange,
    error,
    ...componentProps
  } = props;

  const fieldId = id || name;
  const hasError = !!error;

  const styles = input({ color, hasError });

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (mask && masks[mask]) {
      event.target.value = masks[mask](value);
    }

    if (onChange) {
      onChange(event);
    }
  };

  return {
    styles,
    className,
    fieldId,
    label,
    hideLabel,
    hasError,
    errorMessage: error?.message,
    color,
    componentProps: {
      ...componentProps,
      ref,
      name,
      type,
      onChange: handleOnChange,
    },
  };
};
